<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align: center;"><i>To Nunzio Nappi</i></p>
<p class="first" style="text-align: center;"><i>As long as I can sit in the front seat</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedi.vue?02651610